(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95791,40659,81066,75847,44709,40852,81243,74453,44954,40617,93812,34190],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 34190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Media; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Media/utils/helpers.js
var videoFormats = function(format) {
    return [
        "video/mp4",
        "video/webm", 
    ].includes(format);
};

;// CONCATENATED MODULE: ./UI/components/Media/utils/useMediaProps.js







/* harmony default export */ function useMediaProps(_param) {
    var asset = _param.asset, className = _param.className, isStatic = _param.isStatic, transparent = _param.transparent, loaderParams = _param.loaderParams, displayParams = _param.displayParams, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "asset",
        "className",
        "isStatic",
        "transparent",
        "loaderParams",
        "displayParams"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = get_default()(asset, "fields", {}), contentType = ref1.file.contentType;
    var isVideo = videoFormats(contentType);
    var ref2 = (0,helper/* getImage */.gJ)(asset), url = ref2.url, alt = ref2.alt;
    var imageProps = (0,_object_spread/* default */.Z)({
        alt: alt,
        src: displayParams ? (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            src: url
        }, displayParams)) : url,
        layout: "fill",
        lazyBoundary: "700px",
        unoptimized: true,
        loader: isStatic ? function(param) {
            var src = param.src;
            return src;
        } : function(args) {
            return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
                transparent: transparent
            }, args, loaderParams));
        }
    }, rest);
    return (0,_object_spread/* default */.Z)({
        ref: ref,
        url: url,
        isVideo: isVideo,
        className: className,
        imageProps: imageProps
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Media/styles.module.scss
var styles_module = __webpack_require__(6992);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Media/index.jsx










var Media = function(_param) {
    var renderVideoPlayer = _param.renderVideoPlayer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "renderVideoPlayer"
    ]);
    var _ref = useMediaProps(props), ref = _ref.ref, url = _ref.url, isVideo = _ref.isVideo, className = _ref.className, imageProps = _ref.imageProps, playControl = _ref.playControl, posterUrl = _ref.posterUrl, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref",
        "url",
        "isVideo",
        "className",
        "imageProps",
        "playControl",
        "posterUrl"
    ]);
    if (isVideo) {
        if (renderVideoPlayer) {
            return renderVideoPlayer({
                src: url,
                description: imageProps.alt
            });
        }
        if (playControl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["video-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    controls: true,
                    poster: posterUrl,
                    className: className
                }, rest), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/webm"
                        })
                    ]
                }))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            muted: true,
            autoPlay: true,
            loop: true,
            playsInline: true,
            className: className
        }, rest), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/webm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()((styles_module_default()).image, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, imageProps))
    });
};
Media.propTypes = {
    asset: prop_types_default().instanceOf(Object).isRequired,
    autoPlay: (prop_types_default()).bool,
    loop: (prop_types_default()).bool,
    playsInline: (prop_types_default()).bool,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    renderVideoPlayer: (prop_types_default()).func
};
/* harmony default export */ var components_Media = (Media);


/***/ }),

/***/ 95791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_CaseStudiesStory; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./components/Common/CustomYoutubePlayer/index.jsx
var CustomYoutubePlayer = __webpack_require__(11511);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesStory/utils/useCaseStory.js


/* harmony default export */ function useCaseStory(param) {
    var type = param.type, data = param.data;
    var ref = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[0]", {})), contentModules = ref.contentModules, text = ref.text, title = ref.title;
    var ref1 = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[1]")), videoModule = ref1.contentModules;
    var ref2 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", {})), description = ref2.description, imageTitle = ref2.title, images = ref2.images;
    var imageUrl = (0,helper/* getFileUrl */.qm)(get_default()(images, "[0]", {}));
    var ref3 = (0,helper/* getDocumentFields */.OA)(get_default()(videoModule, "[0]")), videoUrl = ref3.url;
    return {
        type: type,
        text: text,
        title: title,
        description: description,
        imageTitle: imageTitle,
        imageUrl: imageUrl,
        videoUrl: videoUrl
    };
};

// EXTERNAL MODULE: ./UI/sections/CaseStudiesStory/styles.module.scss
var styles_module = __webpack_require__(5975);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesStory/index.jsx














var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var CaseStudiesStory = function(props) {
    var ref = useCaseStory(props), type = ref.type, text = ref.text, title = ref.title, description = ref.description, imageTitle = ref.imageTitle, imageUrl = ref.imageUrl, videoUrl = ref.videoUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default()).section, (styles_module_default())[type]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).contentWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).imagesContainer,
                            children: [
                                imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).imageContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                        transparent: true,
                                        className: (styles_module_default()).image,
                                        src: imageUrl,
                                        alt: imageUrl
                                    })
                                }),
                                imageTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                    variant: "p",
                                    className: (styles_module_default()).imageTitle,
                                    children: imageTitle
                                }),
                                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                    variant: "p",
                                    className: (styles_module_default()).imageDescription,
                                    children: description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).infoContainer,
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                    variant: "h3",
                                    className: (styles_module_default()).infoTitle,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                    document: text
                                })
                            ]
                        })
                    ]
                })
            })),
            videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).videoContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomYoutubePlayer/* CustomYoutubePlayer */.P, {
                        src: (0,helper/* getYoutubeVideoIdFromUrl */.F5)(videoUrl)
                    })
                })
            }))
        ]
    });
};
CaseStudiesStory.propTypes = {
    type: (prop_types_default()).string,
    data: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var sections_CaseStudiesStory = (CaseStudiesStory);


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40659);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var UI_components_Media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34190);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69123);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var GalleryCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 34378).then(__webpack_require__.bind(__webpack_require__, 34378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34378)
            ];
        }
    }
});
var ArticleLink = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(13107), __webpack_require__.e(17396)]).then(__webpack_require__.bind(__webpack_require__, 7002)).then(function(module) {
        return module.ArticleLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7002)
            ];
        }
    }
});
var Table = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 84059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var EmbedArticleCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 80931).then(__webpack_require__.bind(__webpack_require__, 80931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80931)
            ];
        }
    }
});
var Illustration = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 93812).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
// TODO move it to the common folder
// TODO create constants for cases
var ContentfulParser = function(param) {
    var document = param.document, linkIcon = param.linkIcon;
    var _obj, _obj1;
    var options = {
        renderMark: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.CODE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.BOLD, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.ITALIC, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.UNDERLINE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                children: node
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var id = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target.sys.contentType.sys.id", "");
            switch(id){
                case "image":
                    {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", ""), [
                            "articleSingleImageType",
                            "image",
                            "title"
                        ]), articleSingleImageType = ref.articleSingleImageType, rawImage = ref.image, title = ref.title;
                        var image = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getImage */ .gJ)(rawImage);
                        var _obj;
                        return articleSingleImageType && image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().normalImage), articleSingleImageType === "normal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fullImage), articleSingleImageType !== "normal"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, {
                                        type: utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Illustration, {
                                            src: image.url,
                                            alt: image.alt,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().photoCaption),
                                        children: title
                                    })
                                ]
                            })
                        });
                    }
                case "articleGalleryCard":
                    {
                        var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "images",
                            "photoCaption"
                        ]), images = ref1.images, photoCaption = ref1.photoCaption;
                        return images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryCard, {
                            images: images,
                            photoCaption: photoCaption
                        });
                    }
                case "link":
                    {
                        var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref2 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data, [
                            "title",
                            "buttonTitle",
                            "slug",
                            "type",
                            "url",
                            "new", 
                        ]), title1 = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug, type = ref2.type, url = ref2.url, isNew = ref2.new;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLink, {
                            data: data,
                            new: isNew,
                            title: title1,
                            buttonTitle: buttonTitle,
                            slug: slug,
                            type: type,
                            url: url,
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().videoSection)
                        });
                    }
                case "table":
                    {
                        var ref3 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "tableContent",
                            "tableType",
                            "tableText"
                        ]), tableContent = ref3.tableContent, tableType = ref3.tableType, tableText = ref3.tableText;
                        return (tableContent || tableText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Table, {
                            tableData: tableText ? (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .extractContentfulTableData */ .cc)(tableText) : tableContent.tableData,
                            type: tableType
                        });
                    }
                case "article":
                    {
                        var data1 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedArticleCard, {
                            data: data1
                        });
                    }
                case "text":
                    {
                        var data2 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref4 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data2, [
                            "text",
                            "id"
                        ]), text = ref4.text, entryId = ref4.id;
                        return(// eslint-disable-next-line react/no-unknown-property
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "grid-area": entryId,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulParser, {
                                document: text
                            })
                        }));
                    }
                default:
                    return null;
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
            return(// eslint-disable-next-line react/no-unknown-property
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "grid-area": "asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Media__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    asset: data
                })
            }));
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().quote),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h3),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ul),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                type: "1",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ol),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
            var uri = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.uri", "/");
            var isInternalLink = uri.includes(utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .rootUrl */ .Wd);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                path: uri,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().a),
                isLocalLink: isInternalLink,
                children: [
                    children,
                    linkIcon
                ]
            });
        }), _obj1)
    };
    return document ? (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(document, options) : "";
};
ContentfulParser.defaultProps = {
    document: null
};
ContentfulParser.propTypes = {
    document: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = (ContentfulParser);


/***/ }),

/***/ 11511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CustomYoutubePlayer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_microdata_videoUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2608);
/* harmony import */ var utils_youtubeVideosContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76416);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69372);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var CustomYoutubePlayer = function(param) {
    var src = param.src, className = param.className, isArticle = param.isArticle;
    var videoMeta = (0,utils_youtubeVideosContext__WEBPACK_IMPORTED_MODULE_3__/* .useYoutubeVideoMetadata */ .f)(src);
    var microdata = isArticle ? (0,utils_microdata_videoUtils__WEBPACK_IMPORTED_MODULE_4__/* .getVideoObjectMicrodata */ .tI)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, videoMeta), {
        videoId: src
    })) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            microdata && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    id: "JSON-LD-video-".concat(src),
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(microdata)
                    }
                }, "JSON-LD-video-".concat(src))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().player), className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                    width: "853",
                    height: "480",
                    src: "https://www.youtube.com/embed/".concat(src),
                    frameBorder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true,
                    title: "Embedded youtube"
                })
            })
        ]
    });
};
CustomYoutubePlayer.defaultProps = {
    className: "",
    isArticle: false
};
CustomYoutubePlayer.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    isArticle: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool)
};


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 45177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LINK_TYPE; }
/* harmony export */ });
var LINK_TYPE = {
    bookmark: "bookmark",
    callToAction: "call-to-action",
    button: "button",
    youTube: "youtube-video",
    book: "book",
    subscribe: "subscribe",
    scrollBlock: "scroll-block",
    scrollTop: "scroll-top",
    scrollToSection: "scroll-to-section",
    download: "download"
};


/***/ }),

/***/ 2608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t$": function() { return /* binding */ getVideoIdFromEntry; },
/* harmony export */   "tI": function() { return /* binding */ getVideoObjectMicrodata; },
/* harmony export */   "ud": function() { return /* binding */ getVideoIdsFromArticle; }
/* harmony export */ });
/* unused harmony exports getYoutubeVideoUrls, fetchVideosMetadataMap */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_constants_linkType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45177);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6572);
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13107);









function getYoutubeVideoUrls(videoId) {
    return {
        contentUrl: "https://www.youtube.com/watch?v=".concat(videoId),
        embedUrl: "https://www.youtube.com/embed/".concat(videoId),
        thumbnailUrl: "https://i.ytimg.com/vi/".concat(videoId, "/maxresdefault.jpg")
    };
}
function getVideoIdFromEntry(entry) {
    var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getDocumentFields */ .OA)(entry, [
        "type",
        "url"
    ]), type = ref.type, url = ref.url;
    if (type !== utils_constants_linkType__WEBPACK_IMPORTED_MODULE_3__/* .LINK_TYPE.youTube */ .x.youTube || !url) {
        return null;
    }
    return (0,utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getYoutubeVideoIdFromUrl */ .F5)(url);
}
function collectVideoIds(nodes, videoIds) {
    if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) {
        return;
    }
    nodes.forEach(function(node) {
        if (node.nodeType === _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY) {
            var contentTypeId = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(node, "data.target.sys.contentType.sys.id", "");
            if (contentTypeId === "link") {
                var videoId = getVideoIdFromEntry(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(node, "data.target", {}));
                if (videoId) {
                    videoIds.add(videoId);
                }
            }
        }
        if (node.content) {
            collectVideoIds(node.content, videoIds);
        }
    });
}
function getVideoIdsFromArticle(document) {
    var videoIds = new Set();
    collectVideoIds(document === null || document === void 0 ? void 0 : document.content, videoIds);
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(videoIds);
}
function fetchVideosMetadataMap(document) {
    return _fetchVideosMetadataMap.apply(this, arguments);
}
function _fetchVideosMetadataMap() {
    _fetchVideosMetadataMap = _async_to_generator(function(document) {
        var videoIds, entries;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    videoIds = getVideoIdsFromArticle(document);
                    if (!videoIds.length) {
                        return [
                            2,
                            {}
                        ];
                    }
                    return [
                        4,
                        Promise.all(videoIds.map(function() {
                            var _ref = _async_to_generator(function(videoId) {
                                var metadata;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fetchVideoMetadata(videoId)
                                            ];
                                        case 1:
                                            metadata = _state.sent();
                                            return [
                                                2,
                                                metadata ? [
                                                    videoId,
                                                    metadata
                                                ] : null
                                            ];
                                    }
                                });
                            });
                            return function(videoId) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    entries = _state.sent();
                    return [
                        2,
                        Object.fromEntries(entries.filter(Boolean))
                    ];
            }
        });
    });
    return _fetchVideosMetadataMap.apply(this, arguments);
}
function getVideoObjectMicrodata(param) {
    var name = param.name, description = param.description, videoId = param.videoId, uploadDate = param.uploadDate, duration = param.duration, videoThumbnailUrl = param.thumbnailUrl;
    if (!name || !videoId) {
        return null;
    }
    var ref = getYoutubeVideoUrls(videoId), contentUrl = ref.contentUrl, embedUrl = ref.embedUrl, thumbnailUrl = ref.thumbnailUrl;
    var videoObject = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        name: name,
        thumbnailUrl: videoThumbnailUrl || thumbnailUrl,
        contentUrl: contentUrl,
        embedUrl: embedUrl,
        publisher: _data__WEBPACK_IMPORTED_MODULE_5__/* .organisationMicrodata */ .nW
    };
    if (description) {
        videoObject.description = description;
    }
    if (uploadDate) {
        videoObject.uploadDate = uploadDate;
    }
    if (duration) {
        videoObject.duration = duration;
    }
    return videoObject;
}


/***/ }),

/***/ 76416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useYoutubeVideoMetadata; },
/* harmony export */   "z": function() { return /* binding */ YoutubeVideosMetadataContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var YoutubeVideosMetadataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var useYoutubeVideoMetadata = function(videoId) {
    var videosMetadata = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(YoutubeVideosMetadataContext);
    return videosMetadata[videoId];
};


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NnBr_","video-container":"styles_video-container__3YIN0","play-button":"styles_play-button__ubn_b"};

/***/ }),

/***/ 5975:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__A7QiS","contentWrapper":"styles_contentWrapper__uYmRj","infoContainer":"styles_infoContainer__LlCNT","infoTitle":"styles_infoTitle__qeqLS","imagesContainer":"styles_imagesContainer__nB8bk","image":"styles_image__VWPl5","imageTitle":"styles_imageTitle__TAz4K","imageDescription":"styles_imageDescription__Hr0_u","videoContainer":"styles_videoContainer__4a3JD"};

/***/ }),

/***/ 69123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__BMuQY","h3":"styles_h3__wh4p0","paragraph":"styles_paragraph__9NG9P","a":"styles_a__QRxdK","ul":"styles_ul__esYyW","ol":"styles_ol__ue_m_","quote":"styles_quote___48vb","imageWrapper":"styles_imageWrapper__qFsnC","fullImage":"styles_fullImage__qANu4","normalImage":"styles_normalImage__eNnG6","image":"styles_image__Lejqj","photoCaption":"styles_photoCaption__WUS8x","videoSection":"styles_videoSection__g6E1A"};

/***/ }),

/***/ 69372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"player":"styles_player__D9Htw"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);